import { hrBaseApi } from "app/services/HrBaseApi";

export const viewEmployeeApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Employee Details
    getEmployeeDetails: builder.query({
      query: (employeeId) => ({
        url: `/Felix/EmployeeCRUD/?Employee_Id=${employeeId}`,
        method: "GET",
      }),
    }),

    // Update Employee
    updateEmployeeDetails: builder.mutation({
      query: (payload) => ({
        url: `/Felix/EmployeeCRUD/`,
        method: "PUT",
        body: payload,
      }),
    }),

    // Leave Balance
    getEmployeeLeaveBalance: builder.query({
      query: ({ companyId, employeeId, year }) => ({
        url: `/Felix/GetEmployeeLeaveBalance/?Company_Id=${companyId}&Employee_Id=${employeeId}&Year=${year}`,
        method: "GET",
      }),
    }),

    // Update History
    getUpdateRecords: builder.query({
      query: ({ partnerId, documentId }) => ({
        url: `/Felix/Updaterecordsfilter/?Partner_Id=${partnerId}&Document_Id=${documentId}`,
        method: "GET",
      }),
    }),

    // Delete Document
    deleteEmployeeDocument: builder.mutation({
      query: (id) => ({
        url: `/Felix/EmailattachementCRUD/?id=${id}`,
        method: "DELETE",
      }),
    }),

    // Income Tax
    getEmployeeIncomeTax: builder.query({
      query: ({ companyId, employeeId }) => ({
        url: `/Felix/GetEmployeeIncomeTax/?Company_Id=${companyId}&Employee_Id=${employeeId}`,
        method: "GET",
      }),
    }),

    // PF Report
    getEmployeePFReports: builder.mutation({
      query: (payload) => ({
        url: `/Felix/HREmployeePFReports/`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetEmployeeDetailsQuery,
  useUpdateEmployeeDetailsMutation,
  useGetEmployeeLeaveBalanceQuery,
  useGetUpdateRecordsQuery,
  useDeleteEmployeeDocumentMutation,
  useGetEmployeeIncomeTaxQuery,
  useGetEmployeePFReportsMutation,
} = viewEmployeeApi;
